export default __webpack_public_path__ + "static/media/sources.94cc4c41.svg";